var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height stretch"},[_c('sign-in-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }